'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StoresQuadGetApps = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#GetApps_svg__clip0_966_1786)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        fill: "white",
                        fillRule: "evenodd",
                        d: "M34.119 4H21.87C16.118 4 14 6.11 14 11.876v12.248C14 29.89 16.11 32 21.876 32h12.248c5.766 0 7.88-2.11 7.88-7.876V11.876C41.993 6.11 39.884 4 34.118 4",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "#00E691",
                        fillRule: "evenodd",
                        d: "M33.669 36.152H12.17a2.833 2.833 0 0 1-2.832-2.836v-5.761l7.894-7.946z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "#00CCFF",
                        fillRule: "evenodd",
                        d: "M38.555 16.67 21.848-.156h20.966a2.835 2.835 0 0 1 2.832 2.838v6.846z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "#FF5C69",
                        fillRule: "evenodd",
                        d: "M9.34 24.206V2.678q.002-.435.123-.83a2.835 2.835 0 0 1 2.71-2.003h6.7l7.353 7.39z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "#00E08A",
                        d: "M26.76 21.3v-8.253h1.464V21.3z"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "#8F61FF",
                        fillRule: "evenodd",
                        d: "M42.809 36.12h-5.797l-7.471-7.501 16.105-16.171v20.837q-.002.473-.145.897a2.84 2.84 0 0 1-2.692 1.938",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        stroke: "#0FCFFF",
                        strokeWidth: 1.463,
                        d: "m23.212 17.722 4.28 4.281 4.281-4.28"
                    })
                ]
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M13.804 43.632c0 2.093-1.253 3.352-3.368 3.352-2.254 0-3.657-1.532-3.657-4.022 0-2.452 1.397-3.962 3.63-3.962 1.756 0 3.084 1.039 3.336 2.586h-1.403c-.262-.889-.98-1.413-1.928-1.413-1.392 0-2.222 1.033-2.222 2.773 0 1.778.868 2.865 2.26 2.865 1.167 0 1.976-.739 1.997-1.82l.006-.129H10.59v-1.055h3.213zM17.247 42.095c-.75 0-1.29.573-1.344 1.365h2.65c-.026-.803-.54-1.365-1.306-1.365m1.312 3.063h1.248c-.172 1.07-1.168 1.81-2.512 1.81-1.703 0-2.73-1.12-2.73-2.93 0-1.793 1.038-2.976 2.677-2.976 1.611 0 2.618 1.119 2.618 2.843v.434h-3.968v.08c0 .91.557 1.52 1.43 1.52.621 0 1.092-.31 1.237-.781M21.092 39.851h1.333v1.328h1.07v1.028h-1.07v2.95c0 .467.214.68.685.68.123 0 .295-.01.38-.026v1.017a3.7 3.7 0 0 1-.69.054c-1.226 0-1.708-.434-1.708-1.537v-3.138h-.814V41.18h.814zM29.59 46.855l-.66-1.997h-2.843l-.658 1.997h-1.424l2.741-7.726h1.558l2.742 7.726zm-2.1-6.361-1.081 3.298h2.195l-1.076-3.298zM34.858 41.083c1.44 0 2.356 1.12 2.356 2.934 0 1.81-.91 2.93-2.334 2.93-.825 0-1.467-.397-1.778-1.034h-.027v2.811h-1.333v-7.545h1.301v.98h.027c.321-.658.964-1.076 1.788-1.076m-.406 4.77c.862 0 1.397-.711 1.397-1.836 0-1.119-.535-1.836-1.397-1.836-.83 0-1.382.733-1.387 1.836.005 1.114.556 1.837 1.387 1.837M41.188 41.083c1.44 0 2.356 1.12 2.356 2.934 0 1.81-.91 2.93-2.335 2.93-.825 0-1.467-.397-1.778-1.034h-.026v2.811H38.07v-7.545h1.301v.98h.027c.321-.658.964-1.076 1.789-1.076m-.407 4.77c.862 0 1.397-.711 1.397-1.836 0-1.119-.535-1.836-1.397-1.836-.83 0-1.382.733-1.387 1.836.005 1.114.557 1.837 1.387 1.837M44.299 42.807c0-1.039.904-1.745 2.275-1.745 1.382 0 2.26.744 2.292 1.82h-1.242c-.054-.514-.434-.84-1.05-.84-.589 0-.98.278-.98.695 0 .327.236.552.83.686l.943.209c1.178.262 1.633.717 1.633 1.542 0 1.07-.985 1.794-2.377 1.794-1.484 0-2.362-.707-2.469-1.805h1.312c.102.552.482.83 1.157.83.647 0 1.049-.268 1.049-.69 0-.343-.203-.536-.798-.67l-.942-.209c-1.087-.24-1.633-.776-1.633-1.617"
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "GetApps_svg__clip0_966_1786",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: 28.003,
                        height: 28,
                        x: 14,
                        y: 4,
                        fill: "white",
                        rx: 6.601
                    })
                })
            })
        ]
    })));

export { StoresQuadGetApps, StoresQuadGetApps as default };
//# sourceMappingURL=StoresQuadGetApps.js.map
